var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.5 4H21V3C21 1.34312 19.6569 0 18 0H14C12.3431 0 11 1.34312 11 3V4H5.5C4.11931 4 3 5.11931 3 6.5V8.5C3 9.05231 3.44769 9.5 4 9.5H28C28.5523 9.5 29 9.05231 29 8.5V6.5C29 5.11931 27.8807 4 26.5 4ZM13 3C13 2.44875 13.4487 2 14 2H18C18.5513 2 19 2.44875 19 3V4H13V3Z",
    fill: "#BCBFFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.89842 11.5C4.71999 11.5 4.5778 11.6491 4.5863 11.8274L5.4113 29.1425C5.48755 30.745 6.8038 32 8.40755 32H23.5938C25.1975 32 26.5138 30.745 26.59 29.1425L27.4151 11.8274C27.4235 11.6491 27.2814 11.5 27.1029 11.5H4.89842ZM20.0007 14C20.0007 13.4475 20.4482 13 21.0007 13C21.5532 13 22.0007 13.4475 22.0007 14V27C22.0007 27.5525 21.5532 28 21.0007 28C20.4482 28 20.0007 27.5525 20.0007 27V14ZM15.0007 14C15.0007 13.4475 15.4482 13 16.0007 13C16.5532 13 17.0007 13.4475 17.0007 14V27C17.0007 27.5525 16.5532 28 16.0007 28C15.4482 28 15.0007 27.5525 15.0007 27V14ZM10.0007 14C10.0007 13.4475 10.4482 13 11.0007 13C11.5532 13 12.0007 13.4475 12.0007 14V27C12.0007 27.5525 11.5532 28 11.0007 28C10.4482 28 10.0007 27.5525 10.0007 27V14Z",
    fill: "#BCBFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTrash);
export default __webpack_public_path__ + "static/media/icon_trash.7ab717bfb0bf63563a1f0abee324b9d8.svg";
export { ForwardRef as ReactComponent };